import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';

const StyledNavbar = styled(Navbar)`
  background-color: #ffffff;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1);
  padding: 10px 0;
  transition: all 0.3s ease;
  
  &.scrolled {
    padding: 5px 0;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
  }
  
  .container-fluid {
    padding-left: 0;
  }
  
  .navbar-brand {
    margin-right: 20px;
    display: flex;
    align-items: center;
    
    img {
      max-height: 120px;
      width: auto;
    }
    
    span {
      color: #ff9800;
    }
  }
  
  .navbar-collapse {
    flex-grow: 1;
    flex-basis: auto;
  }
  
  .nav-link {
    font-weight: 600;
    color: #333;
    margin: 0 12px;
    transition: color 0.3s ease;
    white-space: nowrap;
    padding: 0.5rem 0;
    
    &:hover, &:focus {
      color: #2e7d32;
    }
    
    &.active {
      color: #2e7d32;
      position: relative;
      
      &:after {
        content: '';
        position: absolute;
        bottom: -3px;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: #2e7d32;
      }
    }
  }
  
  .header-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: nowrap;
  }
  
  .contact-info {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    margin-right: 15px;
    
    @media (max-width: 1200px) {
      display: none;
    }
  }
  
  .contact-item {
    display: flex;
    align-items: center;
    margin-right: 20px;
    color: #555;
    font-weight: 500;
    font-size: 0.9rem;
    white-space: nowrap;
    
    &:last-child {
      margin-right: 0;
    }
    
    svg {
      margin-right: 6px;
      color: #2e7d32;
    }
  }
  
  .cta-button {
    background-color: #ff9800;
    border-color: #ff9800;
    font-weight: 600;
    padding: 10px 20px;
    border-radius: 50px;
    transition: all 0.3s ease;
    white-space: nowrap;
    
    &:hover, &:focus {
      background-color: #f57c00;
      border-color: #f57c00;
      transform: translateY(-2px);
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
    }
  }
  
  .navbar-nav {
    @media (min-width: 992px) {
      margin-left: 40px;
    }
  }
`;

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleNavCollapse = () => setExpanded(false);

  return (
    <StyledNavbar
      expand="lg"
      fixed="top"
      className={scrolled ? 'scrolled' : ''}
      expanded={expanded}
    >
      <Container fluid="lg" className="px-0 px-sm-3">
        <Navbar.Brand as={Link} to="/" className="ms-0">
          <img src="/images/Bering_Solutions_Logo.png" alt="Bering Solutions LLC" />
        </Navbar.Brand>
        <Navbar.Toggle 
          aria-controls="basic-navbar-nav" 
          onClick={() => setExpanded(expanded ? false : "expanded")} 
        />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/" onClick={handleNavCollapse}>Home</Nav.Link>
            <Nav.Link as={Link} to="/about" onClick={handleNavCollapse}>About Us</Nav.Link>
            <Nav.Link as={Link} to="/how-it-works" onClick={handleNavCollapse}>How It Works</Nav.Link>
            <Nav.Link as={Link} to="/contact" onClick={handleNavCollapse}>Contact Us</Nav.Link>
          </Nav>
          <div className="header-right">
            <div className="contact-info">
              <div className="contact-item">
                <FontAwesomeIcon icon={faPhone} />
                <span>786-460-6046</span>
              </div>
              <div className="contact-item">
                <FontAwesomeIcon icon={faEnvelope} />
                <span>connect@beringsolutions.com</span>
              </div>
            </div>
            <Button 
              as={Link} 
              to="/get-offer" 
              className="cta-button"
              onClick={handleNavCollapse}
            >
              Get Cash Offer
            </Button>
          </div>
        </Navbar.Collapse>
      </Container>
    </StyledNavbar>
  );
};

export default Header;
